// extracted by mini-css-extract-plugin
export default {"wrapper":"Iq-z","response":"Jq-z","error":"Kq-z","disabled":"Lq-z","buttons":"Mq-z","feedbackQuestionSection":"Nq-z","yesNoWrapper":"Oq-z"};